/**
 * @type {string}
 * @description - The FILTER web component.
 */
export const FILTERS_WEB_COMPONENT = 'wesog-filters-component';

/**
 * @type {string}
 * @description - The custom loading spinner web component.
 */
export const CUSTOM_LOADING_SPINNER_WEB_COMPONENT = 'loading-spinner-component';

/**
 * @type {string}
 * @description - The custom main loading spinner web component.
 */
export const CUSTOM_MAIN_LOADING_SPINNER_WEB_COMPONENT = '[data-main-spinner]';

/**
 * @type {string}
 * @description - The custom data loading spinner web component.
 */
export const CUSTOM_DATA_LOADING_SPINNER_WEB_COMPONENT = '[data-loading-spinner]';

/**
 * @type {string}
 * @description - The custom main base layout web component.
 */
export const MAIN_BASE_LAYOUT_WEB_COMPONENT = '[data-base-layout]';
